// Safely extract a numeric timestamp from an item using common keys
const extractStart = (item) => {
  if (!item || typeof item !== 'object') return 0;
  const candidates = [
    item.startDate,
    item.fromDate,
    item.start,
    item.startedAt,
    item.begin,
    item.date, // some sections just have single date
  ];
  for (const v of candidates) {
    if (v == null) continue;
    // numeric
    if (typeof v === 'number') return v;
    // string numeric timestamp
    if (typeof v === 'string' && /^\d{10,}$/.test(v.replace(/[^0-9]/g, ''))) {
      const n = Number(v.replace(/[^0-9]/g, ''));
      if (!Number.isNaN(n)) return n;
    }
    // ISO date string
    if (typeof v === 'string') {
      const t = Date.parse(v);
      if (!Number.isNaN(t)) return t;
    }
  }
  return 0;
};

// Safely extract a numeric timestamp from an item using end date keys
const extractEnd = (item) => {
  if (!item || typeof item !== 'object') return 0;
  
  // Handle "isCurrent" field - if it's "Yes", treat as Present
  if (item.isCurrent === "Yes") {
    return Number.MAX_SAFE_INTEGER; // Latest possible timestamp
  }
  
  const candidates = [
    item.endDate,
    item.toDate,
    item.end,
    item.endedAt,
    item.finish,
    item.completedAt,
    // Fallback to start date if no end date
    item.startDate,
    item.fromDate,
    item.start,
    item.startedAt,
    item.begin,
    item.date,
  ];
  for (const v of candidates) {
    if (v == null) continue;
    // Handle "Present" as the latest possible date
    if (typeof v === 'string' && (v.toLowerCase() === 'present' || v.toLowerCase() === 'current')) {
      return Number.MAX_SAFE_INTEGER; // Latest possible timestamp
    }
    // numeric
    if (typeof v === 'number') return v;
    // string numeric timestamp
    if (typeof v === 'string' && /^\d{10,}$/.test(v.replace(/[^0-9]/g, ''))) {
      const n = Number(v.replace(/[^0-9]/g, ''));
      if (!Number.isNaN(n)) return n;
    }
    // ISO date string
    if (typeof v === 'string') {
      const t = Date.parse(v);
      if (!Number.isNaN(t)) return t;
    }
  }
  return 0;
};

export const sortByStartDateDesc = (arr = []) => {
  return [...arr].sort((a, b) => extractStart(b) - extractStart(a));
};

export const sortByEndDateDesc = (arr = []) => {
  return [...arr].sort((a, b) => extractEnd(b) - extractEnd(a));
};

export const sortNestedProjectsByStartDateDesc = (employment) => {
  if (!employment || !Array.isArray(employment.projects)) return employment;
  return {
    ...employment,
    projects: sortByStartDateDesc(employment.projects),
  };
};

export const sortNestedProjectsByEndDateDesc = (employment) => {
  if (!employment || !Array.isArray(employment.projects)) return employment;
  return {
    ...employment,
    projects: sortByEndDateDesc(employment.projects),
  };
};


